import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PerimeterExhibitsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M7 7h10v10h-1a2 2 0 00-2 2v1a2 2 0 002 2h4a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h4a2 2 0 002-2v-1a2 2 0 00-2-2H7V7zm0-2h1V4H7v1zM5 8V7H4v1h1zm0 2H4v1h1v-1zM4 5h1V4H4v1zm15 15h1v-1h-1v1zm-2 0v-1h-1v1h1zm2-3h1v-1h-1v1zm1-3v-1h-1v1h1zm0-3h-1v-1h1v1zm0-3V7h-1v1h1zm0-3h-1V4h1v1zm-4 0h1V4h-1v1zm-2-1v1h-1V4h1zm-3 0h-1v1h1V4zM5 20v-1H4v1h1zm2 0v-1h1v1H7zm-3-7h1v1H4v-1zm0 3v1h1v-1H4z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
PerimeterExhibitsIcon.isCarinaIcon = true;
export default PerimeterExhibitsIcon;
